import React, { Component } from 'react'

export default class Sidebar extends Component {
  render() {
    return (
      <div>
        <div>
          <nav href="#navbar" className="js-colorlib-nav-toggle colorlib-nav-toggle" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar"><i /></nav>
          <aside id="colorlib-aside" className="border js-fullheight">
            <div className="text-center">
              <div className="author-img" style={{backgroundImage: 'url(images/about.jpg)'}} />

              <h1 id="colorlib-logo"><a href="index.html">Antti Saaristo</a></h1>
              <span className="email"><i className="icon-mail"></i> antti.saaristo (at) gmail.com</span>
            </div>
            <nav id="colorlib-main-menu" role="navigation" className="navbar">
              <div id="navbar" className="collapse">
                <ul>
                  <li className="active"><a href="#home" data-nav-section="home">Introduction</a></li>
                  <li><a href="#about" data-nav-section="about">About</a></li>
                  
                  
                  { /*<li><a href="#" data-nav-section="blog">Blog</a></li> */}
                  <li><a href="#testtools" data-nav-section="timeline">Testing Tools</a></li>
                  <li><a href="#projects" data-nav-section="projects">Robot Framework</a></li>
                </ul>
              </div>
            </nav>
            <nav id="colorlib-main-menu">
              <ul>
                { /* 
                <li><a href="https://www.facebook.com/dhruv.barochia" target="_blank" rel="noopener noreferrer"><i className="icon-facebook2" /></a></li>
                <li><a href="https://twitter.com/ddbarochiya" target="_blank" rel="noopener noreferrer"><i className="icon-twitter2" /></a></li>
                <li><a href="https://www.instagram.com/ddbarochiya/" target="_blank" rel="noopener noreferrer"><i className="icon-instagram" /></a></li>
                */ }
                <li><a href="https://linkedin.com/in/antti-saaristo-12790a2" target="_blank" rel="noopener noreferrer"><i className="icon-linkedin2" /></a></li>
                <li><a href="https://github.com/SaaristoAntti" target="_blank" rel="noopener noreferrer"><i className="icon-github"></i></a></li>
                { /* <li><a href="https://medium.com/@dhruv.barochia34788" target="_blank" rel="noopener noreferrer"><i className="icon-blogger2"></i></a></li> */ }
              </ul>
            </nav>
            <div className="colorlib-footer">
              <p><small>
                  
                  Find beautiful themes from <a href="https://colorlib.com" target="_blank" rel="noopener noreferrer">Colorlib</a>
                  <br></br><i className="icon-beer" aria-hidden="true" /> Cheers! <i className="icon-beer" aria-hidden="true"></i><br></br>
              </small></p>
              { /*<p><small>
              We only see what we know.
              </small></p> */ }
            </div>
          </aside>
        </div>
      </div>
    )
  }
}
